<template>
  <v-card max-width="500" outlined :loading="loading" class="mx-auto">
    <v-card-text>
      <v-row>
        <v-col cols="10">
          <v-slider v-model="slider" :max="maxSlider" hide-details>
            <template v-slot:prepend>
              <div style="padding-top: 5px;">
                <div v-if="player">{{ renderTime(currentTime) }}</div>
                <div v-else>00:00</div>
              </div>
            </template>
            <template v-slot:append>
              <div style="padding-top: 5px;">
                <div v-if="maxSlider">{{ renderTime(maxSlider) }}</div>
                <div v-else>00:00</div>
              </div>
            </template>
          </v-slider>
        </v-col>
        <v-col cols="2">
          <v-btn
            :href="downloadLink || src"
            target="_blank"
            download
            icon
            color="primary"
          >
            <v-icon>mdi-download</v-icon></v-btn
          >
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col cols="3">
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon color="primary" v-bind="attrs" v-on="on">
                <v-icon>{{ volumeIcons() }}</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-text>
                <v-slider vertical v-model="volume">
                  <template v-slot:append>
                    <span
                      style="
                        font-size: 14px;
                        text-transform: none;
                        letter-spacing: normal;
                        font-weight: 600;
                      "
                      >%{{ volume }}</span
                    >
                  </template>
                </v-slider>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-col>

        <v-col cols="2" align="center">
          <v-btn icon color="primary" outlined @click="jump(-10)">
            <v-icon>mdi-rewind-10</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="2" align="center">
          <v-btn
            icon
            color="primary"
            large
            outlined
            v-if="!playing"
            @click="play(src)"
          >
            <v-icon>mdi-play</v-icon>
          </v-btn>
          <v-btn
            icon
            color="primary"
            large
            outlined
            v-if="playing"
            @click="pause()"
          >
            <v-icon>mdi-pause</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="2" align="center">
          <v-btn icon color="primary" outlined @click="jump(10)">
            <v-icon>mdi-fast-forward-10</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="3" align="right">
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                v-bind="attrs"
                text
                v-on="on"
                style="text-transform: none;"
              >
                x{{ speeds[speed] }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item-group v-model="speed" color="primary">
                <v-list-item v-for="(item, idx) in speeds" :key="idx">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    src: String,
    downloadLink: String,
  },
  data() {
    return {
      playing: false,
      slider: 0,
      maxSlider: 0,
      currentTime: 0,
      player: null,
      loading: false,
      speed: 3,
      speeds: [0.25, 0.5, 0.75, 1.0, 1.25, 1.5, 1.75, 2.0],
      volume: 100,
    };
  },
  // not `created` for nuxt
  mounted() {
    this.initialise();
  },
  watch: {
    src() {
      this.initialise();
    },
    slider(v) {
      if (this.player) {
        if (Math.abs(this.player.currentTime - this.slider) > 1) {
          this.player.currentTime = v;
        }
      }
    },
    speed(v) {
      this.player.playbackRate = this.speeds[v];
    },
    volume(v) {
      this.player.volume = v / 100;
    },
  },
  methods: {
    initialise() {
      if (this.src) {
        this.loading = true;
        this.player = new Audio(this.src);
        this.player.addEventListener("timeupdate", () => {
          this.currentTime = this.player.currentTime;
          this.slider = this.currentTime;
        });
        this.player.addEventListener("loadedmetadata", () => {
          this.loading = false;
          this.maxSlider = this.player.duration;
        });
        this.player.playbackRate = 1;
      }
    },
    play() {
      this.playing = true;
      this.player.play();
    },
    pause() {
      this.player.pause();
      this.playing = false;
    },
    stop() {
      this.pause();
      this.player.currentTime = 0;
    },
    renderTime(time) {
      let total = Math.floor(time);
      let seconds = total % 60;
      return Math.floor(total / 60) + ":" + (seconds < 10 ? "0" : "") + seconds;
    },
    volumeIcons() {
      if (this.volume >= 50) {
        return "mdi-volume-high";
      } else if (this.volume === 0) {
        return "mdi-volume-off";
      }
      return "mdi-volume-medium";
    },
    jump(num) {
      this.player.currentTime += num;
    },
  },
};
</script>
